<template>
  <component
    :is="transitionType"
    :tag="tag"
    v-bind="$attrs"
    @enter="enter"
    @leave="leave"
  >
    <slot/>
  </component>
</template>

<script>
import * as TweenMax from "gsap/umd/TweenMax";

export default {
  name: "SlideTransition",
  props: {
    group: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    transitionType() {
      return this.group ? "transition-group" : "transition";
    }
  },
  methods: {
    enter(el, done) {
      const self = this;
      TweenMax.fromTo(
        el,
        0.3,
        { x: "110%", opacity: 0 },
        {
          x: "0%",
          opacity: 1,
          clearProps: "width",
          onComplete() {
            self.makePositionRelative(el, done);
          },
          ease: Power1.easeOut, // eslint-disable-line no-undef
          delay: 0.1
        }
      );
    },
    leave(el, done) {
      TweenMax.to(el, 0.3, {
        x: "-110%",
        opacity: 0,
        position: "absolute",
        width: this.setElementWidth(el),
        onComplete: done,
        ease: Power1.easeOut // eslint-disable-line no-undef
      });
    },
    makePositionRelative(el, done) {
      done();
      if (el.style.position) {
        el.style.position = "relative";
      }
    },
    setElementWidth(el) {
      if (el.clientWidth) {
        el.style.width = `${el.clientWidth}px`;
      }
      return el;
    }
  }
};
</script>
